/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EquipmentDisciplineDataDTO
 */
export interface EquipmentDisciplineDataDTO {
    /**
     * 
     * @type {string}
     * @memberof EquipmentDisciplineDataDTO
     */
    disciplinaName?: string | null;
}

export function EquipmentDisciplineDataDTOFromJSON(json: any): EquipmentDisciplineDataDTO {
    return EquipmentDisciplineDataDTOFromJSONTyped(json, false);
}

export function EquipmentDisciplineDataDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EquipmentDisciplineDataDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'disciplinaName': !exists(json, 'disciplinaName') ? undefined : json['disciplinaName'],
    };
}

export function EquipmentDisciplineDataDTOToJSON(value?: EquipmentDisciplineDataDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'disciplinaName': value.disciplinaName,
    };
}

